import styled from "styled-components";
import { layout, space, LayoutProps, SpaceProps } from "styled-system";
import { useVisuallyHidden } from "@react-aria/visually-hidden";

import logo from "./cag-logo.png";

const LogoImg = styled.img<{
  height: LayoutProps["height"];
  ml?: SpaceProps["marginLeft"];
}>`
  ${layout}
  ${space}
`;

const CagLogo = () => {
  const { visuallyHiddenProps } = useVisuallyHidden();

  return (
    <a href="/">
      <LogoImg
        // @ts-ignore
        height={{ default: "32px", desktop: "50px" }}
        ml={{ default: "10px", desktop: "0" }}
        src={logo}
        alt="constellation automotive logo"
        aria-hidden="true"
      />
      <p {...visuallyHiddenProps}>Constellation automotive group</p>
    </a>
  );
};

export default CagLogo;
